import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { MaskText, SectionLabel } from './ui/Reveal';
import { MagneticButton } from './ui/MagneticButton';
import { links, stats } from '../data/site';

/**
 * No fabricated quotes — this section routes visitors to the real,
 * external client feedback page supplied in the brief.
 */
export function Testimonials() {
  return <section className="bg-surface2 py-20 sm:py-28" aria-label="Client feedback" data-id="element-559" data-mp="36yzcmhr8ouk9">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-560" data-mp="36wmotnysvpza">
        <div className="grid gap-12 border-t border-line pt-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-end" data-id="element-561" data-mp="31ybezd8i9fh2">
          <div data-id="element-562" data-mp="2x11t27kbrlxz">
            <SectionLabel data-id="element-563" data-mp="2x2w5exhj65qg">Client feedback</SectionLabel>
            <h2 className="mt-5 max-w-2xl font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tightest sm:text-6xl" data-id="element-564" data-mp="2s2rvxrf1ib9q">
              <MaskText text="Don’t Just Take|Our Word For It." data-id="element-565" data-mp="v7c8xd3zhhsk" />
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-muted sm:text-lg" data-id="element-566" data-mp="qav9hmrc3h06">
              See what clients have to say about working with Morvix.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3" data-id="element-567" data-mp="m62oe2hse3ss">
              <MagneticButton href={links.reviews} cursorLabel="Read reviews" showArrow data-id="element-568" data-mp="78aa1dnz7lg6">
                Read Client Reviews
              </MagneticButton>
              <span className="label text-muted" data-id="element-569" data-mp="c8y09x4dry9c">Verified on Trustpilot</span>
            </div>
          </div>

          <div className="relative border border-line bg-surface p-8" data-id="element-570" data-mp="zyscqdksfkt2">
            <QuoteIcon className="h-8 w-8 text-brand" aria-hidden="true" data-id="element-571" data-mp="14uzmyik7vigt" />
            <p className="mt-6 font-serif text-3xl italic leading-tight sm:text-4xl" data-id="element-572" data-mp="q5lav2p9amxq">
              {stats[2].value}%+ client satisfaction across {stats[1].value}+ delivered projects.
            </p>
            <div className="mt-6 flex items-center gap-1.5" aria-hidden="true" data-id="element-573" data-mp="1iu90fah1fyh3">
              {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-brand text-brand" data-id="element-574" data-mp="1no3e9x9ypj89" data-mpi={index} />)}
            </div>
            <p className="label mt-4 text-muted" data-id="element-575" data-mp="1siweikqe608u">Verified feedback published off-site</p>
          </div>
        </div>
      </div>
    </section>;
}